import { isNumber } from 'lodash';
/**
 * Handler for converting a startDate to an odata filter
 * This helper function lets you pass a date, and the keys
 * for your date range, and then returns an OData "or" prop
 * to be passed into an odata query.
 *
 * Converts to "key1 ge startDate or key2 ge startDate or key3..."
 * when processed to an odata query string.
 */
export const startDateFilter = (
/** Looking for dates that are greater than or equal to this date */
startDate, 
/**
 * An array of all the date columns an item may be found in.
 *
 * @example ['revisionDate','releaseDate']
 */
dateKeyList) => dateFilterFactory(startDate, dateKeyList, 'ge');
/**
 * Handler for converting a endDate to an odata filter
 * This helper function lets you pass a date, and the keys
 * for your date range, and then returns an OData "or" prop
 * to be passed into an odata query.
 *
 * Converts to "key1 le startDate or key2 le startDate or key3..."
 * when processed to an odata query string.
 */
export const endDateFilter = (
/** Looking for dates that are less than or equal to this date */
endDate, 
/**
 * An array of all the date columns an item may be found in.
 *
 * @example ['revisionDate','releaseDate']
 */
dateKeyList) => dateFilterFactory(endDate, dateKeyList, 'le');
/**
 * Handler for converting a date to an odata filter
 * This helper function lets you pass a date, and the keys
 * for your date range, and then returns an OData "or" prop
 * to be passed into an odata query.
 *
 * > You may want to check out startDateFilter & endDateFilter if they fit your needs.
 */
export const dateFilterFactory = (date, dateKeyList, operator) => {
    if (!date) {
        return null;
    }
    try {
        const parsedDate = mergeDateTypes(date);
        const cleanDate = parsedDate.toISOString();
        let result = {};
        dateKeyList.forEach(key => {
            result[key] = { data: cleanDate, operator };
        });
        return result;
    }
    catch (e) {
        return null;
    }
};
const mergeDateTypes = (d) => {
    if (d instanceof Date) {
        return d;
    }
    if (isNumber(d)) {
        return new Date(d);
    }
    return new Date(d);
};
